import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-2 text-white text-sm md:text-base" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "|", -1)

import { useI18n } from "vue-i18n";
import Toggle from "@/components/atoms/Toggle.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t, locale } = useI18n();

const changeLocale = (lang: string) => {
  locale.value = lang;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Toggle, {
      active: _unref(locale) === 'fr',
      onClick: _cache[0] || (_cache[0] = ($event: any) => (changeLocale('fr'))),
      "aria-label": _unref(t)('options.locale.fr.long')
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("options.locale.fr.short")), 1)
      ]),
      _: 1
    }, 8, ["active", "aria-label"]),
    _hoisted_2,
    _createVNode(Toggle, {
      active: _unref(locale) === 'en',
      onClick: _cache[1] || (_cache[1] = ($event: any) => (changeLocale('en'))),
      "aria-label": _unref(t)('options.locale.en.long')
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("options.locale.en.short")), 1)
      ]),
      _: 1
    }, 8, ["active", "aria-label"])
  ]))
}
}

})